<script>
export default {
  props: {
    guiasAssociadas: Object
  },
}
</script>

<template>
  <v-card>
    <v-card-title>
      Guias associadas
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <h3>Ids de guias de pagamento</h3>
        </v-col>
        <v-col>
          <h3>Ids de guias de faturamento</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          {{ guiasAssociadas.filteredPagamentoGuias.join(', ') }}
        </v-col>
        <v-col>
          {{ guiasAssociadas.filteredFaturamentoGuias.join(', ') }}
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style scoped>
</style>
